import * as ACTIONS from "./../actions/actionConstants";

const initialState = {
  logs: []
};

const logsReducer = (state = initialState, action) => {
  switch (action.type) {
    //from sagas/db on INIT
    case ACTIONS.FETCH_LOGS: {
      return {
        ...state,
        logs: action.payload
      };
    }
    case ACTIONS.UPDATE_LOGS: {
      return {
        ...state,
        logs: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export default logsReducer;



// WEBPACK FOOTER //
// ./src/reducers/logsReducer.js